import { render, staticRenderFns } from "./artworkList.vue?vue&type=template&id=c1268d8c&scoped=true&"
import script from "./artworkList.vue?vue&type=script&lang=js&"
export * from "./artworkList.vue?vue&type=script&lang=js&"
import style0 from "./artworkList.vue?vue&type=style&index=0&id=c1268d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1268d8c",
  null
  
)

export default component.exports